<p-confirmDialog appendTo="body" />
<div class="info-panel">
  @if (bulkEditMode()) {
    <div class="bulk-edit-bar">
      <span class="bulk-edit-bar__count">
        {{ changedFieldsCount() }} campo{{ changedFieldsCount() === 1 ? '' : 's' }} alterado{{
          changedFieldsCount() === 1 ? '' : 's'
        }}
      </span>
      <div class="bulk-edit-bar__actions">
        <p-button
          label="Cancelar"
          severity="secondary"
          [outlined]="true"
          size="small"
          [disabled]="saving()"
          (onClick)="requestCancelBulkEdit()" />
        <p-button
          label="Aplicar"
          size="small"
          [loading]="saving()"
          [disabled]="changedFieldsCount() === 0"
          (onClick)="applyBulkEdit()" />
      </div>
    </div>
  }

  <!-- Seção Principal - Campos Mais Importantes -->
  <div class="info-section">
    <h3 class="info-section-title section-collapsible" (click)="toggleSection('principais')">
      Informações Principais
      <i
        [class]="sectionExpanded().principais ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        class="section-chevron"></i>
    </h3>
    @if (sectionExpanded().principais) {
      <!-- 0. Situação -->
      <div class="info-field critical-field">
        <span class="info-label">Situação</span>
        <div class="situation-container">
          <span class="info-value" [class]="getSituationClass()">
            {{ getSituationDescription() }}
          </span>
          <div class="situation-actions">
            @if (ticket.situation === 'A') {
              <span
                class="close-button-wrapper"
                [pTooltip]="closeBlockedTooltip"
                tooltipPosition="top">
                <p-button
                  label="Fechar"
                  icon="pi pi-lock"
                  severity="secondary"
                  variant="outlined"
                  [loading]="saving()"
                  [disabled]="isCloseBlocked"
                  (onClick)="closeTicket()"
                  size="small" />
              </span>
            } @else {
              <p-button
                label="Reabrir"
                icon="pi pi-lock-open"
                severity="secondary"
                variant="outlined"
                [loading]="saving()"
                (onClick)="reopenTicket()"
                size="small" />
            }
          </div>
        </div>
      </div>

      <!-- 1. Urgente -->
      <div class="info-field critical-field">
        <span class="info-label">Urgente</span>
        <div class="urgent-container">
          <span class="info-value" [class]="ticket.urgent ? 'urgent-yes' : 'urgent-no'">
            {{ ticket.urgent ? 'Sim' : 'Não' }}
          </span>
          <div class="urgent-actions">
            <p-toggleSwitch
              [(ngModel)]="editUrgent"
              (onChange)="toggleUrgent()"
              [disabled]="saving()" />
          </div>
        </div>
      </div>

      <!-- 2. Cliente -->
      <div class="info-field editable-field critical-field">
        <div class="flex align-items-center mb-1">
          <span class="info-label mb-0">Cliente</span>
          @if (ticket.customer?.id) {
            <p-button
              icon="pi pi-info-circle"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              [pTooltip]="'Informações do Cliente'"
              tooltipPosition="bottom"
              (onClick)="openCustomerDetailModal()"
              styleClass="p-0 ml-1 w-2rem h-2rem ticket-customer-info-btn" />
          }
        </div>
        @if (editingField() === 'customer_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Cliente"
              placeholder="Nenhum cliente selecionado"
              searchPlaceholder="Buscar cliente..."
              labelField="_name"
              [searchFn]="searchCustomersFn"
              [value]="currentCustomerSeed"
              (valueChange)="onCustomerSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketCustomers" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('customer_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('customer_id')"
            (keydown.enter)="startEdit('customer_id')">
            {{
              ticket.customer_code
                ? ticket.customer_code + ' - ' + ticket.customer_name
                : ticket.customer_name
            }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 2. Sistema -->
      <div class="info-field editable-field critical-field">
        <span class="info-label">Sistema</span>
        @if (editingField() === 'system_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Sistema"
              placeholder="Nenhum sistema selecionado"
              searchPlaceholder="Buscar sistema..."
              labelField="description"
              [searchFn]="searchSystemsFn"
              [value]="currentSystemSeed"
              (valueChange)="onSystemSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketSystems" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('system_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('system_id')"
            (keydown.enter)="startEdit('system_id')">
            {{ ticket.system?.description ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 3. Solicitante -->
      <div class="info-field editable-field critical-field">
        <span class="info-label">Solicitante</span>
        @if (editingField() === 'requester' || bulkEditMode()) {
          <div class="edit-inline">
            <input
              [appAutoEditFocus]="!bulkEditMode()"
              type="text"
              pInputText
              [(ngModel)]="editRequester"
              class="edit-input-text"
              placeholder="Nome do solicitante"
              (keydown.enter)="onFieldEnterKey('requester')"
              (keydown.escape)="onFieldEscapeKey()" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('requester')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('requester')"
            (keydown.enter)="startEdit('requester')">
            {{ ticket.requester || '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 4. Prioridade -->
      <div class="info-field editable-field critical-field">
        <span class="info-label">Prioridade</span>
        @if (editingField() === 'priority' || bulkEditMode()) {
          <div class="edit-inline">
            <p-select
              [appAutoEditFocus]="!bulkEditMode()"
              [options]="priorityOptions"
              [(ngModel)]="editPriority"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione a prioridade"
              [style]="{ width: '100%' }"
              styleClass="edit-select"
              appendTo="body" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('priority')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('priority')"
            (keydown.enter)="startEdit('priority')">
            {{ ticket.priority }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 7. Status -->
      <div class="info-field editable-field critical-field">
        <span class="info-label">Status</span>
        @if (editingField() === 'ticket_status_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Status"
              placeholder="Nenhum status selecionado"
              searchPlaceholder="Buscar status..."
              labelField="description"
              [searchFn]="searchTicketStatusesFn"
              [value]="currentStatusSeed"
              (valueChange)="onTicketStatusSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketStatuses" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('ticket_status_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('ticket_status_id')"
            (keydown.enter)="startEdit('ticket_status_id')">
            {{ ticket.status?.description ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 8. Responsável -->
      <div class="info-field editable-field critical-field">
        <span class="info-label">Responsável</span>
        @if (editingField() === 'responsible_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Responsável"
              placeholder="Nenhum responsável selecionado"
              searchPlaceholder="Buscar responsável..."
              labelField="name"
              [searchFn]="searchUsersFn"
              [value]="currentUserSeeds.get(editResponsibleId)"
              (valueChange)="onResponsibleSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketResponsibles" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('responsible_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('responsible_id')"
            (keydown.enter)="startEdit('responsible_id')">
            {{ ticket.responsible?.name ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 9. Desenvolvedor -->
      <div class="info-field editable-field">
        <span class="info-label">Desenvolvedor</span>
        @if (editingField() === 'developer_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Desenvolvedor"
              placeholder="Nenhum desenvolvedor selecionado"
              searchPlaceholder="Buscar desenvolvedor..."
              labelField="name"
              [searchFn]="searchUsersFn"
              [value]="currentUserSeeds.get(editDeveloperId)"
              (valueChange)="onDeveloperSelected($event)"
              [allowClearSelection]="true"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketDevelopers" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('developer_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('developer_id')"
            (keydown.enter)="startEdit('developer_id')">
            {{ ticket.developer?.name ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 10. Executor -->
      <div class="info-field editable-field">
        <span class="info-label">Executor</span>
        @if (editingField() === 'executor_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Executor"
              placeholder="Nenhum executor selecionado"
              searchPlaceholder="Buscar executor..."
              labelField="name"
              [searchFn]="searchUsersFn"
              [value]="currentUserSeeds.get(editExecutorId)"
              (valueChange)="onExecutorSelected($event)"
              [allowClearSelection]="true"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketExecutors" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('executor_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('executor_id')"
            (keydown.enter)="startEdit('executor_id')">
            {{ ticket.executor?.name ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 11. Participantes -->
      <div class="info-field editable-field">
        <span class="info-label">Participantes</span>
        @if (editingField() === 'participant_ids' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Participantes"
              placeholder="Nenhum participante selecionado"
              searchPlaceholder="Buscar participantes..."
              labelField="name"
              [multiple]="true"
              [searchFn]="searchUsersFn"
              [value]="participantEntities()"
              (valueChange)="onParticipantsSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketParticipants" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('participant_ids')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('participant_ids')"
            (keydown.enter)="startEdit('participant_ids')">
            {{ getParticipantsDisplay() }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>
    }
  </div>

  <!-- Seção Secundária - Campos Adicionais -->
  <div class="info-section">
    <h3 class="info-section-title section-collapsible" (click)="toggleSection('adicionais')">
      Informações Adicionais
      <i
        [class]="sectionExpanded().adicionais ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        class="section-chevron"></i>
    </h3>
    @if (sectionExpanded().adicionais) {
      <!-- 10. Esforço Técnico -->
      <div class="info-field editable-field">
        <div class="info-label-effort">
          <span class="info-label">Esforço Técnico</span>
          <p-checkbox
            [ngModel]="shouldRecalculateTaskEffort()"
            [binary]="true"
            [disabled]="!canEdit"
            (onChange)="onShouldRecalculateChange($event.checked)"
            pTooltip="Marcado: calculado automaticamente pelas tarefas. Desmarcado: valor manual."
            tooltipPosition="top" />
        </div>
        @if (
          (editingField() === 'estimated_effort' || bulkEditMode()) &&
          !shouldRecalculateTaskEffort()
        ) {
          <div class="edit-inline">
            <p-inputNumber
              [appAutoEditFocus]="!bulkEditMode()"
              [(ngModel)]="editEstimatedEffort"
              [min]="0"
              [maxFractionDigits]="2"
              size="small"
              styleClass="edit-input-number"
              (onKeyDown)="
                $event.code === 'Enter' && onFieldEnterKey('estimated_effort');
                $event.code === 'Escape' && onFieldEscapeKey()
              " />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('estimated_effort')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else if (shouldRecalculateTaskEffort()) {
          <span class="info-value">
            {{ ticket.estimated_effort || '—' }}
            <i class="pi pi-calculator" style="font-size: 0.75rem; opacity: 0.6"></i>
          </span>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('estimated_effort')"
            (keydown.enter)="startEdit('estimated_effort')">
            {{ ticket.estimated_effort || '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 10b. Esforço Comercial -->
      <div class="info-field editable-field">
        <span class="info-label">Esforço Comercial</span>
        @if (editingField() === 'commercial_estimated_effort' || bulkEditMode()) {
          <div class="edit-inline">
            <p-inputNumber
              [appAutoEditFocus]="!bulkEditMode()"
              [(ngModel)]="editCommercialEstimatedEffort"
              [min]="0"
              [maxFractionDigits]="2"
              size="small"
              styleClass="edit-input-number"
              (onKeyDown)="
                $event.code === 'Enter' && onFieldEnterKey('commercial_estimated_effort');
                $event.code === 'Escape' && onFieldEscapeKey()
              " />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('commercial_estimated_effort')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('commercial_estimated_effort')"
            (keydown.enter)="startEdit('commercial_estimated_effort')">
            {{ ticket.commercial_estimated_effort || '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 11. Previsão Análise -->
      <div class="info-field editable-field">
        <span class="info-label">Previsão Análise</span>
        @if (editingField() === 'analysis_expected_date' || bulkEditMode()) {
          <div class="edit-inline">
            <p-datepicker
              [appAutoEditFocus]="!bulkEditMode()"
              [(ngModel)]="editAnalysisExpectedDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              styleClass="edit-datepicker"
              appendTo="body" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('analysis_expected_date')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('analysis_expected_date')"
            (keydown.enter)="startEdit('analysis_expected_date')">
            {{ formatDateShort(ticket.analysis_expected_date) }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 12. Previsão Desenvolvimento -->
      <div class="info-field editable-field">
        <span class="info-label">Previsão Desenvolvimento</span>
        @if (editingField() === 'development_expected_date' || bulkEditMode()) {
          <div class="edit-inline">
            <p-datepicker
              [appAutoEditFocus]="!bulkEditMode()"
              [(ngModel)]="editDevelopmentExpectedDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              styleClass="edit-datepicker"
              appendTo="body" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('development_expected_date')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('development_expected_date')"
            (keydown.enter)="startEdit('development_expected_date')">
            {{ formatDateShort(ticket.development_expected_date) }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 13. Previsão Final -->
      <div class="info-field editable-field">
        <span class="info-label">Previsão Final</span>
        @if (editingField() === 'expected_date' || bulkEditMode()) {
          <div class="edit-inline">
            <p-datepicker
              [appAutoEditFocus]="!bulkEditMode()"
              [(ngModel)]="editExpectedDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              styleClass="edit-datepicker"
              appendTo="body" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('expected_date')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('expected_date')"
            (keydown.enter)="startEdit('expected_date')">
            {{ formatDateShort(ticket.expected_date) }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 14. Tipo Chamada -->
      <div class="info-field editable-field">
        <span class="info-label">Tipo Chamada</span>
        @if (editingField() === 'ticket_type_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Tipo de Chamada"
              placeholder="Nenhum tipo selecionado"
              searchPlaceholder="Buscar tipo de chamada..."
              labelField="description"
              [searchFn]="searchTicketTypesFn"
              [value]="currentTicketTypeSeed"
              (valueChange)="onTicketTypeSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketTypes" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('ticket_type_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('ticket_type_id')"
            (keydown.enter)="startEdit('ticket_type_id')">
            {{ ticket.ticket_type?.description || '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 15. Tipo -->
      <div class="info-field editable-field">
        <span class="info-label">Tipo</span>
        @if (editingField() === 'type' || bulkEditMode()) {
          <div class="edit-inline">
            <p-select
              [appAutoEditFocus]="!bulkEditMode()"
              [options]="ticketsTypes"
              [(ngModel)]="editType"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione o tipo..."
              [style]="{ width: '100%' }"
              styleClass="edit-select"
              appendTo="body"
              [showClear]="true" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('type')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('type')"
            (keydown.enter)="startEdit('type')">
            {{ getTypeLabel(ticket.type) }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 16. Assunto -->
      <div class="info-field editable-field">
        <span class="info-label">Assunto</span>
        @if (editingField() === 'issue_id' || bulkEditMode()) {
          <div class="edit-inline">
            <app-entity-picker
              [autoOpen]="!bulkEditMode()"
              (closed)="onPickerClosed()"
              title="Selecionar Assunto"
              placeholder="Nenhum assunto selecionado"
              searchPlaceholder="Buscar assunto..."
              labelField="_description"
              [searchFn]="searchIssuesFn"
              [value]="currentIssueSeed"
              (valueChange)="onIssueSelected($event)"
              [favorites]="true"
              [favoritesKey]="FavoriteKey.TicketIssues" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('issue_id')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('issue_id')"
            (keydown.enter)="startEdit('issue_id')">
            {{
              (ticket.issue?.ref ? ticket.issue?.ref + ' - ' : '') +
                (ticket.issue?.description ?? '') || '—'
            }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 17. Email -->
      <div class="info-field editable-field">
        <span class="info-label">Email</span>
        @if (editingField() === 'email' || bulkEditMode()) {
          <div class="edit-inline">
            <input
              [appAutoEditFocus]="!bulkEditMode()"
              type="email"
              pInputText
              [(ngModel)]="editEmail"
              class="edit-input-text"
              placeholder="email@exemplo.com"
              (keydown.enter)="onFieldEnterKey('email')"
              (keydown.escape)="onFieldEscapeKey()" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('email')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('email')"
            (keydown.enter)="startEdit('email')">
            {{ ticket.email || '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 17. Telefone -->
      <div class="info-field editable-field">
        <span class="info-label">Telefone</span>
        @if (editingField() === 'phone' || bulkEditMode()) {
          <div class="edit-inline">
            <input
              [appAutoEditFocus]="!bulkEditMode()"
              type="tel"
              pInputText
              [mask]="'(00) 0 0000-0000||(00) 0000-0000'"
              [(ngModel)]="editPhone"
              class="edit-input-text"
              placeholder="(xx) x xxxx-xxxx"
              (keydown.enter)="onFieldEnterKey('phone')"
              (keydown.escape)="onFieldEscapeKey()" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('phone')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('phone')"
            (keydown.enter)="startEdit('phone')">
            {{
              (stripCountryCode(ticket.phone ?? '') | mask: '(00) 0 0000-0000||(00) 0000-0000') ||
                '—'
            }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- 18. Tags -->
      <div class="info-field editable-field">
        <span class="info-label">Tags</span>
        @if (editingField() === 'ticket_tags' || bulkEditMode()) {
          <div class="edit-inline tags-edit">
            <patron-chips
              [appAutoEditFocus]="!bulkEditMode()"
              [(values)]="editTags"
              placeholder="Adicionar tags..."
              class="w-full" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('ticket_tags')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <div
            class="info-value clickable tags-display"
            tabindex="0"
            role="button"
            (click)="startEdit('ticket_tags')"
            (keydown.enter)="startEdit('ticket_tags')">
            @if (ticket.ticket_tags && ticket.ticket_tags.length > 0) {
              <div class="tags-container">
                @for (tt of ticket.ticket_tags; track tt.id) {
                  <p-tag [value]="tt.tag.name" severity="info" />
                }
              </div>
            } @else {
              —
            }
            <i class="pi pi-pencil edit-icon"></i>
          </div>
        }
      </div>
    }
  </div>

  <!-- Seção Desenvolvimento -->
  <div class="info-section">
    <h3 class="info-section-title section-collapsible" (click)="toggleSection('desenvolvimento')">
      Desenvolvimento
      <i
        [class]="sectionExpanded().desenvolvimento ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        class="section-chevron"></i>
    </h3>
    @if (sectionExpanded().desenvolvimento) {
      <!-- Projeto -->
      <div class="info-field editable-field">
        <span class="info-label">Projeto</span>
        @if (editingField() === 'project_id' || bulkEditMode()) {
          <div class="edit-inline">
            <p-select
              [appAutoEditFocus]="!bulkEditMode()"
              [options]="projectsList()"
              [(ngModel)]="editProjectId"
              optionLabel="description"
              optionValue="id"
              placeholder="Buscar projeto..."
              [filter]="true"
              (onFilter)="onProjectFilter($event)"
              [loading]="projectsLoading"
              [emptyMessage]="projectsLoading ? 'Buscando...' : 'Nenhum projeto encontrado'"
              [emptyFilterMessage]="projectsLoading ? 'Buscando...' : 'Nenhum projeto encontrado'"
              [style]="{ width: '100%' }"
              styleClass="edit-select"
              appendTo="body"
              [showClear]="true" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('project_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('project_id')"
            (keydown.enter)="startEdit('project_id')">
            {{ ticket.project?.description ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- Fase -->
      <div class="info-field editable-field">
        <span class="info-label">Fase</span>
        @if (editingField() === 'phase_id' || bulkEditMode()) {
          <div class="edit-inline">
            <p-select
              [appAutoEditFocus]="!bulkEditMode()"
              [options]="phasesList()"
              [(ngModel)]="editPhaseId"
              optionLabel="description"
              optionValue="id"
              placeholder="Buscar fase..."
              [filter]="true"
              (onFilter)="onPhaseFilter($event)"
              [loading]="phasesLoading"
              [emptyMessage]="phasesLoading ? 'Buscando...' : 'Nenhuma fase encontrada'"
              [emptyFilterMessage]="phasesLoading ? 'Buscando...' : 'Nenhuma fase encontrada'"
              [style]="{ width: '100%' }"
              styleClass="edit-select"
              appendTo="body"
              [showClear]="true" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button class="edit-btn save" (click)="saveField('phase_id')" [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('phase_id')"
            (keydown.enter)="startEdit('phase_id')">
            {{ ticket.phase?.description ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>

      <!-- Sprint -->
      <div class="info-field editable-field">
        <span class="info-label">Sprint</span>
        @if (editingField() === 'sprint_id' || bulkEditMode()) {
          <div class="edit-inline">
            <p-select
              [appAutoEditFocus]="!bulkEditMode()"
              [options]="sprintsList()"
              [(ngModel)]="editSprintId"
              optionLabel="description"
              optionValue="id"
              placeholder="Buscar sprint..."
              [filter]="true"
              (onFilter)="onSprintFilter($event)"
              [loading]="sprintsLoading"
              [emptyMessage]="sprintsLoading ? 'Buscando...' : 'Nenhum sprint encontrado'"
              [emptyFilterMessage]="sprintsLoading ? 'Buscando...' : 'Nenhum sprint encontrado'"
              [style]="{ width: '100%' }"
              styleClass="edit-select"
              appendTo="body"
              [showClear]="true" />
            @if (!bulkEditMode()) {
              <div class="edit-actions">
                <button
                  class="edit-btn save"
                  (click)="saveField('sprint_id')"
                  [disabled]="saving()">
                  <i class="pi pi-check"></i>
                </button>
                <button class="edit-btn cancel" (click)="cancelEdit()">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            }
          </div>
        } @else {
          <span
            class="info-value clickable"
            tabindex="0"
            role="button"
            (click)="startEdit('sprint_id')"
            (keydown.enter)="startEdit('sprint_id')">
            {{ ticket.sprint?.description ?? '—' }}
            <i class="pi pi-pencil edit-icon"></i>
          </span>
        }
      </div>
    }
  </div>
</div>

<app-customer-detail-modal
  [customerId]="customerIdForModal()"
  [visible]="customerDetailModalVisible()"
  (visibleChange)="customerDetailModalVisible.set($event)" />
